import { computed, ComputedRef } from 'vue';
import { getAppVariable } from '@white-label-helper/get-app-variable';
import type { POI } from '@white-label-types/parking-booking';
import type { CartItem, Item } from '@white-label-types/parking-checkout';

type SummaryElement = CartItem | Item;

type AirportType = {
  airport: ComputedRef<{ code: string; name: string }>;
}

export function getAirport(product?: SummaryElement): AirportType {
  const airport = computed(() => {
    const airportCode =
      product?.search_criteria?.[product?.product_code]?.airport_code ||
      product?.locationInfo?.code;

    const airport = getAppVariable('pois').find(
      (poi: POI) => poi.code === airportCode
    );

    let name = '';
    let code = '';

    if (airport) {
      if (airport.code === 'BFS') {
        name = 'Belfast International';
      } else if (airport.code === 'LCY') {
        name = 'London City';
      } else {
        name = airport.name
          .replace(/International|Airport|London/g, '')
          .trim();
      }
      code = airport.code;
    }

    return { code, name };
  });

  return { airport };
}
